function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useContext } from 'react';
import { Box, Typography, FormControlLabel, Grid2 as Grid, MenuItem, Stack, Switch, TextField, Container } from '@mui/material';
import { ConfigContext, FileInputButtons } from '../components';
var DeloitteBlackLOGO = '/DeloitteBlackLOGO.svg';
import { Circle, AddCircleOutlineOutlined } from '@mui/icons-material';
import PickerFull from '../components/Settings/PickerFull';
var PreviewButton = function PreviewButton(_ref) {
    var _ref$height = _ref.height, height = _ref$height === void 0 ? '20px' : _ref$height, _ref$width = _ref.width, width = _ref$width === void 0 ? '85px' : _ref$width, _ref$content = _ref.content, content = _ref$content === void 0 ? '' : _ref$content, _ref$color = _ref.color, color = _ref$color === void 0 ? '#000000' : _ref$color, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? '#FFFFFF' : _ref$backgroundColor, _ref$alignment = _ref.alignment, alignment = _ref$alignment === void 0 ? 'center' : _ref$alignment;
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            borderRadius: 'calc(infinity * 1px)',
            backgroundColor: backgroundColor,
            height: height,
            width: width,
            color: color,
            display: 'flex',
            justifyContent: alignment,
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: 600
        }
    }, content);
};
var ImageTitle = function ImageTitle(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            mb: 1,
            fontWeight: 600
        }
    }, children);
};
var PageImage = function PageImage(_ref3) {
    var height = _ref3.height, width = _ref3.width, settings = _ref3.settings;
    return /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: settings === null || settings === void 0 ? void 0 : settings.page_image,
        alt: "Page image",
        sx: {
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            height: height,
            width: width
        }
    });
};
var colorDropdownOptions = ['#FFFFFF', '#000000', '#26890D', '#007CB0', '#0D8390', '#E89623'];
var Theme = function Theme(_ref4) {
    var _configState$settings, _configState$settings2, _configState$settings3, _process$env$REACT_AP, _configState$settings4;
    var settings = _ref4.settings, setSettings = _ref4.setSettings;
    var _useContext = useContext(ConfigContext), configState = _useContext.configState;
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), customizeLoginScreen = _useState2[0], setCustomizeLoginScreen = _useState2[1];
    var _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), customizeHeaders = _useState4[0], setCustomizeHeaders = _useState4[1];
    var _useState5 = useState(false), _useState6 = _slicedToArray(_useState5, 2), showPickerLogin = _useState6[0], setShowPickerLogin = _useState6[1];
    var _useState7 = useState(false), _useState8 = _slicedToArray(_useState7, 2), showPickerHeaders = _useState8[0], setShowPickerHeaders = _useState8[1];
    var _useState9 = useState(''), _useState0 = _slicedToArray(_useState9, 2), selectedColorField = _useState0[0], setSelectedColorField = _useState0[1];
    var handleTextChange = function handleTextChange(key, value) {
        setSettings(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, value));
        });
    };
    return /*#__PURE__*/ React.createElement(Container, {
        sx: {
            p: 3,
            backgroundColor: '#F8F8F8'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: '#FFFFFF',
            p: 3,
            borderRadius: '8px',
            mb: 2
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 15
    }, /*#__PURE__*/ React.createElement(Grid, {
        size: showPickerLogin ? 4 : 5
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        sx: {
            mb: 2
        }
    }, "Login screen"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 2
        }
    }, "Personalize your login screen by customizing the image, button color, and background color for a professional, tailored experience."), customizeLoginScreen && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            background: "".concat(settings === null || settings === void 0 ? void 0 : settings.background_color),
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            height: '200px',
            width: '350px',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-around'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '5px'
        }
    }, /*#__PURE__*/ React.createElement(PreviewButton, {
        content: "Welcome to",
        color: settings === null || settings === void 0 ? void 0 : settings.welcome_message_color,
        backgroundColor: settings === null || settings === void 0 ? void 0 : settings.background_color,
        alignment: "start"
    }), /*#__PURE__*/ React.createElement(PreviewButton, {
        content: "Product Name",
        color: settings === null || settings === void 0 ? void 0 : settings.welcome_message_color,
        backgroundColor: settings === null || settings === void 0 ? void 0 : settings.background_color,
        alignment: "start"
    }), /*#__PURE__*/ React.createElement(PreviewButton, {
        height: "16px",
        width: "50px",
        content: "Button",
        color: settings === null || settings === void 0 ? void 0 : settings.button_text_color,
        backgroundColor: settings === null || settings === void 0 ? void 0 : settings.button_color
    })), settings !== null && settings !== void 0 && settings.page_image_file ? /*#__PURE__*/ React.createElement(PageImage, {
        width: "150px",
        height: "140px",
        settings: settings
    }) : /*#__PURE__*/ React.createElement(Box, {
        component: "div",
        sx: {
            width: 150,
            height: 140,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "div",
        dangerouslySetInnerHTML: {
            __html: configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.page_image
        },
        sx: {
            width: '100%',
            height: '100%',
            '& svg': {
                height: '100% !important',
                width: '100% !important',
                objectFit: 'cover',
                display: 'block'
            },
            '& img': {
                height: '100%',
                width: '100%',
                objectFit: 'cover'
            }
        }
    })))), /*#__PURE__*/ React.createElement(Grid, {
        size: showPickerLogin ? 4 : 7
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
        }
    }, /*#__PURE__*/ React.createElement(FormControlLabel, {
        control: /*#__PURE__*/ React.createElement(Switch, null),
        label: "Customize log in screen",
        checked: customizeLoginScreen,
        onChange: function onChange(_, checked) {
            setCustomizeLoginScreen(checked);
            setShowPickerLogin(false);
        }
    }), customizeLoginScreen && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TextField, {
        id: "background-color",
        select: true,
        label: "Background color",
        value: ((settings === null || settings === void 0 ? void 0 : settings.background_color) || '').toUpperCase(),
        onChange: function onChange(e) {
            handleTextChange('background_color', e.target.value.toUpperCase());
            setShowPickerLogin(false);
        },
        fullWidth: true,
        slotProps: {
            select: {
                renderValue: function renderValue(value) {
                    return /*#__PURE__*/ React.createElement(Stack, {
                        direction: "row",
                        alignItems: "center",
                        gap: 1
                    }, /*#__PURE__*/ React.createElement(Circle, {
                        fontSize: "small",
                        sx: {
                            color: value
                        }
                    }), value);
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        key: 'customColor',
        value: settings === null || settings === void 0 ? void 0 : settings.background_color,
        onClick: function onClick() {
            setShowPickerLogin(true);
            setSelectedColorField('background_color');
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(AddCircleOutlineOutlined, {
        fontSize: "small",
        sx: {
            color: '#26890D'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "#26890D",
        fontWeight: 600
    }, "Custom Color"))), colorDropdownOptions.map(function (color) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: color,
            value: color
        }, /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            alignItems: "center",
            gap: 1
        }, /*#__PURE__*/ React.createElement(Circle, {
            fontSize: "small",
            sx: {
                color: color
            }
        }), color));
    })), /*#__PURE__*/ React.createElement(TextField, {
        id: "button-color",
        select: true,
        label: "Button color",
        value: ((settings === null || settings === void 0 ? void 0 : settings.button_color) || '').toUpperCase(),
        onChange: function onChange(e) {
            handleTextChange('button_color', e.target.value.toUpperCase());
            setShowPickerLogin(false);
        },
        fullWidth: true,
        slotProps: {
            select: {
                renderValue: function renderValue(value) {
                    return /*#__PURE__*/ React.createElement(Stack, {
                        direction: "row",
                        alignItems: "center",
                        gap: 1
                    }, /*#__PURE__*/ React.createElement(Circle, {
                        fontSize: "small",
                        sx: {
                            color: value
                        }
                    }), value);
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        key: 'customColor',
        value: settings === null || settings === void 0 ? void 0 : settings.button_color,
        onClick: function onClick() {
            setShowPickerLogin(true);
            setSelectedColorField('button_color');
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(AddCircleOutlineOutlined, {
        fontSize: "small",
        sx: {
            color: '#26890D'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "#26890D",
        fontWeight: 600
    }, "Custom Color"))), colorDropdownOptions.map(function (color) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: color,
            value: color
        }, /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            alignItems: "center",
            gap: 1
        }, /*#__PURE__*/ React.createElement(Circle, {
            fontSize: "small",
            sx: {
                color: color
            }
        }), color));
    })), /*#__PURE__*/ React.createElement(TextField, {
        id: "button-text-color",
        select: true,
        label: "Button text color",
        value: ((settings === null || settings === void 0 ? void 0 : settings.button_text_color) || '').toUpperCase(),
        onChange: function onChange(e) {
            handleTextChange('button_text_color', e.target.value.toUpperCase());
            setShowPickerLogin(false);
        },
        fullWidth: true,
        slotProps: {
            select: {
                renderValue: function renderValue(value) {
                    return /*#__PURE__*/ React.createElement(Stack, {
                        direction: "row",
                        alignItems: "center",
                        gap: 1
                    }, /*#__PURE__*/ React.createElement(Circle, {
                        fontSize: "small",
                        sx: {
                            color: value
                        }
                    }), value);
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        key: 'customColor',
        value: settings === null || settings === void 0 ? void 0 : settings.button_text_color,
        onClick: function onClick() {
            setShowPickerLogin(true);
            setSelectedColorField('button_text_color');
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(AddCircleOutlineOutlined, {
        fontSize: "small",
        sx: {
            color: '#26890D'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "#26890D",
        fontWeight: 600
    }, "Custom Color"))), colorDropdownOptions.map(function (color) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: color,
            value: color
        }, /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            alignItems: "center",
            gap: 1
        }, /*#__PURE__*/ React.createElement(Circle, {
            fontSize: "small",
            sx: {
                color: color
            }
        }), color));
    })), /*#__PURE__*/ React.createElement(TextField, {
        id: "welcome-message-color",
        select: true,
        label: "Welcome message color",
        value: ((settings === null || settings === void 0 ? void 0 : settings.welcome_message_color) || '').toUpperCase(),
        onChange: function onChange(e) {
            handleTextChange('welcome_message_color', e.target.value.toUpperCase());
            setShowPickerLogin(false);
        },
        fullWidth: true,
        slotProps: {
            select: {
                renderValue: function renderValue(value) {
                    return /*#__PURE__*/ React.createElement(Stack, {
                        direction: "row",
                        alignItems: "center",
                        gap: 1
                    }, /*#__PURE__*/ React.createElement(Circle, {
                        fontSize: "small",
                        sx: {
                            color: value
                        }
                    }), value);
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        key: 'customColor',
        value: settings === null || settings === void 0 ? void 0 : settings.welcome_message_color,
        onClick: function onClick() {
            setShowPickerLogin(true);
            setSelectedColorField('welcome_message_color');
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(AddCircleOutlineOutlined, {
        fontSize: "small",
        sx: {
            color: '#26890D'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "#26890D",
        fontWeight: 600
    }, "Custom Color"))), colorDropdownOptions.map(function (color) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: color,
            value: color
        }, /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            alignItems: "center",
            gap: 1
        }, /*#__PURE__*/ React.createElement(Circle, {
            fontSize: "small",
            sx: {
                color: color
            }
        }), color));
    })), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(ImageTitle, null, "Page image"), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            borderRadius: 1,
            border: '1px solid #D9D9D9',
            background: 'transparent',
            width: '250px',
            height: '150px'
        }
    }, settings !== null && settings !== void 0 && settings.page_image_file ? /*#__PURE__*/ React.createElement(PageImage, {
        width: "250px",
        height: "150px",
        settings: settings
    }) : /*#__PURE__*/ React.createElement(Box, {
        component: "div",
        sx: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "div",
        dangerouslySetInnerHTML: {
            __html: configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.page_image
        },
        sx: {
            width: '100%',
            height: '100%',
            '& svg': {
                height: '100% !important',
                width: '100% !important',
                objectFit: 'cover',
                display: 'block'
            },
            '& img': {
                height: '100%',
                width: '100%',
                objectFit: 'cover'
            }
        }
    }))), /*#__PURE__*/ React.createElement(FileInputButtons, {
        setSettings: setSettings,
        targetKey: "page_image"
    }))))), /*#__PURE__*/ React.createElement(Grid, {
        size: showPickerLogin ? 4 : 0
    }, showPickerLogin && /*#__PURE__*/ React.createElement(PickerFull, {
        setColor: function setColor(val) {
            handleTextChange(selectedColorField, val.toUpperCase());
            setShowPickerLogin(false);
        },
        defaultColor: settings === null || settings === void 0 ? void 0 : settings[selectedColorField]
    })))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: '#FFFFFF',
            p: 3,
            borderRadius: '8px',
            mb: 7
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 15
    }, /*#__PURE__*/ React.createElement(Grid, {
        size: showPickerHeaders ? 4 : 5
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        sx: {
            mb: 2
        }
    }, "Headers"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 2
        }
    }, "Customize your app headers with a background or logo to ensure a unified, professional look across all applications and the home screen."), customizeHeaders && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            height: '200px',
            width: '436px'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            alignItems: 'center',
            background: settings === null || settings === void 0 ? void 0 : settings.header_background_color,
            borderBottom: '1px solid #d9d9d9',
            borderRadius: '4px 4px 0 0',
            display: 'flex',
            gap: '8px',
            px: 2,
            py: 1
        }
    }, (settings === null || settings === void 0 ? void 0 : settings.show_deloitte_logo) && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: DeloitteBlackLOGO,
        alt: "Deloitte",
        sx: {
            height: '15px'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            fontSize: '20px',
            mb: 0.5,
            color: settings === null || settings === void 0 ? void 0 : settings.workspace_name_color
        }
    }, "|")), (settings === null || settings === void 0 ? void 0 : settings.show_logo) && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
        }
    }, settings !== null && settings !== void 0 && settings.header_logo_image_file ? /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: settings === null || settings === void 0 ? void 0 : settings.header_logo_image,
        alt: "Logo in header",
        sx: {
            height: '16px',
            width: '20px'
        }
    }) : /*#__PURE__*/ React.createElement(Box, {
        component: "div",
        dangerouslySetInnerHTML: {
            __html: configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.header_logo_image
        },
        sx: {
            display: 'flex',
            height: 16,
            width: 20,
            '& svg': {
                height: '100% !important',
                width: '100% !important',
                maxHeight: '16px !important',
                maxWidth: '20px !important',
                display: 'block',
                overflow: 'hidden'
            },
            '& img': {
                height: '100%',
                width: '100%',
                maxHeight: '16px',
                maxWidth: '20px',
                objectFit: 'contain'
            }
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            fontSize: '20px',
            mb: 0.5,
            color: settings === null || settings === void 0 ? void 0 : settings.workspace_name_color
        }
    }, "|")), (settings === null || settings === void 0 ? void 0 : settings.show_workspace_name) && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            color: settings === null || settings === void 0 ? void 0 : settings.workspace_name_color
        }
    }, settings === null || settings === void 0 ? void 0 : settings.workspace_name), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            fontSize: '20px',
            mb: 0.5,
            color: settings === null || settings === void 0 ? void 0 : settings.workspace_name_color
        }
    }, "|")), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            color: settings === null || settings === void 0 ? void 0 : settings.workspace_name_color
        }
    }, (_process$env$REACT_AP = process.env.REACT_APP_NAME) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : '')), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            fontSize: '12px',
            padding: '20px',
            width: '75%'
        }
    }, "Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis libero tenetur aut corrupti quam perferendis quia laudantium sit"))), /*#__PURE__*/ React.createElement(Grid, {
        size: showPickerHeaders ? 4 : 7
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '24px'
        }
    }, /*#__PURE__*/ React.createElement(FormControlLabel, {
        control: /*#__PURE__*/ React.createElement(Switch, null),
        label: "Customize headers",
        checked: customizeHeaders,
        onChange: function onChange(_, checked) {
            setCustomizeHeaders(checked);
            setShowPickerHeaders(false);
        }
    }), customizeHeaders && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TextField, {
        id: "header-background",
        select: true,
        label: "Header background",
        value: ((settings === null || settings === void 0 ? void 0 : settings.header_background_color) || '').toUpperCase(),
        onChange: function onChange(e) {
            handleTextChange('header_background_color', e.target.value.toUpperCase());
            setShowPickerHeaders(false);
        },
        fullWidth: true,
        slotProps: {
            select: {
                renderValue: function renderValue(value) {
                    return /*#__PURE__*/ React.createElement(Stack, {
                        direction: "row",
                        alignItems: "center",
                        gap: 1
                    }, /*#__PURE__*/ React.createElement(Circle, {
                        fontSize: "small",
                        sx: {
                            color: value
                        }
                    }), value);
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        key: 'customColor',
        value: settings === null || settings === void 0 ? void 0 : settings.header_background_color,
        onClick: function onClick() {
            setShowPickerHeaders(true);
            setSelectedColorField('header_background_color');
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(AddCircleOutlineOutlined, {
        fontSize: "small",
        sx: {
            color: '#26890D'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "#26890D",
        fontWeight: 600
    }, "Custom Color"))), colorDropdownOptions.map(function (color) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: color,
            value: color
        }, /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            alignItems: "center",
            gap: 1
        }, /*#__PURE__*/ React.createElement(Circle, {
            fontSize: "small",
            sx: {
                color: color
            }
        }), color));
    }), /*#__PURE__*/ React.createElement(MenuItem, {
        key: 'linear-gradient',
        value: 'linear-gradient(270deg, #47BC32 0%, #056FAD 58.65%)'
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(Circle, {
        fontSize: "small",
        sx: {
            background: 'linear-gradient(270deg, #47BC32 0%, #056FAD 58.65%)',
            color: '#FFFFFF'
        }
    }), 'linear-gradient(270deg, #47BC32 0%, #056FAD 58.65%)'.toUpperCase()))), /*#__PURE__*/ React.createElement(TextField, {
        id: "workspace-name",
        label: "Workspace name",
        value: settings === null || settings === void 0 ? void 0 : settings.workspace_name,
        onChange: function onChange(e) {
            return handleTextChange('workspace_name', e.target.value);
        },
        fullWidth: true,
        helperText: "We suggest you use a studio or client name."
    }), /*#__PURE__*/ React.createElement(TextField, {
        id: "workspace-name-color",
        select: true,
        label: "Workspace name color",
        value: ((settings === null || settings === void 0 ? void 0 : settings.workspace_name_color) || '').toUpperCase(),
        onChange: function onChange(e) {
            handleTextChange('workspace_name_color', e.target.value.toUpperCase());
            setShowPickerHeaders(false);
        },
        fullWidth: true,
        slotProps: {
            select: {
                renderValue: function renderValue(value) {
                    return /*#__PURE__*/ React.createElement(Stack, {
                        direction: "row",
                        alignItems: "center",
                        gap: 1
                    }, /*#__PURE__*/ React.createElement(Circle, {
                        fontSize: "small",
                        sx: {
                            color: value
                        }
                    }), value);
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        key: 'customColor',
        value: settings === null || settings === void 0 ? void 0 : settings.workspace_name_color,
        onClick: function onClick() {
            setShowPickerHeaders(true);
            setSelectedColorField('workspace_name_color');
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(AddCircleOutlineOutlined, {
        fontSize: "small",
        sx: {
            color: '#26890D'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "#26890D",
        fontWeight: 600
    }, "Custom Color"))), colorDropdownOptions.map(function (color) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: color,
            value: color
        }, /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            alignItems: "center",
            gap: 1
        }, /*#__PURE__*/ React.createElement(Circle, {
            fontSize: "small",
            sx: {
                color: color
            }
        }), color));
    })), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(FormControlLabel, {
        control: /*#__PURE__*/ React.createElement(Switch, null),
        label: "Use a logo for the workspace",
        checked: settings === null || settings === void 0 ? void 0 : settings.show_logo,
        onChange: function onChange(_, checked) {
            return handleTextChange('show_logo', checked);
        },
        sx: {
            mb: 1
        }
    }), (settings === null || settings === void 0 ? void 0 : settings.show_logo) && /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            backgroundColor: '#EBEBEB',
            borderRadius: '4px',
            width: '250px',
            height: '90px',
            py: 1,
            px: 1.5
        }
    }, settings !== null && settings !== void 0 && settings.header_logo_image_file ? /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: settings === null || settings === void 0 ? void 0 : settings.header_logo_image,
        alt: "Logo in header",
        sx: {
            height: '76px',
            width: '100%'
        }
    }) : /*#__PURE__*/ React.createElement(Box, {
        component: "div",
        sx: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            '& svg': {
                height: '100% !important',
                width: '100% !important',
                maxHeight: '76px !important',
                maxWidth: '100% !important',
                objectFit: 'contain',
                display: 'block'
            },
            '& img': {
                height: '100%',
                width: '100%',
                maxHeight: '76px',
                maxWidth: '100%',
                objectFit: 'contain'
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "div",
        dangerouslySetInnerHTML: {
            __html: configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.header_logo_image
        },
        sx: {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            '& svg': {
                height: '100% !important',
                width: '100% !important',
                maxHeight: '76px !important',
                maxWidth: '100% !important',
                display: 'block',
                overflow: 'hidden'
            },
            '& img': {
                height: '100%',
                width: '100%',
                maxHeight: '76px',
                maxWidth: '100%',
                objectFit: 'contain'
            }
        }
    }))), /*#__PURE__*/ React.createElement(FileInputButtons, {
        setSettings: setSettings,
        targetKey: "header_logo_image"
    }))), /*#__PURE__*/ React.createElement(FormControlLabel, {
        control: /*#__PURE__*/ React.createElement(Switch, null),
        label: "Show the workspace name on application headers",
        checked: settings === null || settings === void 0 ? void 0 : settings.show_workspace_name,
        onChange: function onChange(_, checked) {
            return handleTextChange('show_workspace_name', checked);
        }
    }), /*#__PURE__*/ React.createElement(FormControlLabel, {
        control: /*#__PURE__*/ React.createElement(Switch, null),
        label: "Show the Deloitte logo in the headers",
        checked: settings === null || settings === void 0 ? void 0 : settings.show_deloitte_logo,
        onChange: function onChange(_, checked) {
            return handleTextChange('show_deloitte_logo', checked);
        }
    })))), /*#__PURE__*/ React.createElement(Grid, {
        size: showPickerHeaders ? 4 : 0
    }, showPickerHeaders && /*#__PURE__*/ React.createElement(PickerFull, {
        setColor: function setColor(val) {
            handleTextChange(selectedColorField, val.toUpperCase());
            setShowPickerHeaders(false);
        },
        defaultColor: settings === null || settings === void 0 ? void 0 : settings[selectedColorField]
    })))));
};
export default Theme;
